export default {
  cleanup: (): void => {
    document.querySelectorAll('#chatbot')?.forEach((element) => element.remove());
    document.querySelectorAll('#tabist-care-widget-root')?.forEach((element) => element.remove());
    document
      .querySelectorAll('script[src*="tabist-care-chat-widget"]')
      ?.forEach((element) => element.remove());

    const windowState = window as unknown as Record<string, unknown>;
    const loadedFlag = '__TABIST_CARE_WIDGET_LOADED__';
    windowState[loadedFlag] = undefined;
    windowState.TabistCareWidget = undefined;

    document.querySelectorAll('script[src*="tripla"]')?.forEach((element) => element.remove());
    document
      .querySelectorAll('link[rel="stylesheet"][href*="tripla"]')
      ?.forEach((element) => element.remove());
    document.querySelectorAll('#tripla-app')?.forEach((element) => element.remove());
    document.querySelectorAll('#triplabot-styling')?.forEach((element) => element.remove());
    document.querySelectorAll('#tripla-booking-modal')?.forEach((element) => element.remove());
    Object.keys(window)
      .filter((key) => key.toLowerCase().includes('tripla'))
      .forEach((key) => {
        (window as unknown as Record<string, unknown>)[key] = undefined;
      });
  },
  initialize: (
    propertyId?: string,
    propertyName?: string,
    locale?: string,
    chatbotKey?: string
  ): void => {
    if (
      propertyId &&
      propertyName &&
      locale &&
      process.env.NEXT_PUBLIC_CHATBOT_BASE_URL &&
      process.env.NEXT_PUBLIC_CHATBOT_LOADER_PATH &&
      process.env.NEXT_PUBLIC_CHATBOT_APP_CLIENT_KEY &&
      process.env.NEXT_PUBLIC_CHATBOT_API_URL &&
      process.env.NEXT_PUBLIC_CHATBOT_WS_URL
    ) {
      const script = document.createElement('script');
      script.id = 'chatbot';
      script.src = new URL(
        `${process.env.NEXT_PUBLIC_CHATBOT_BASE_URL}${process.env.NEXT_PUBLIC_CHATBOT_LOADER_PATH}`
      ).toString();
      script.setAttribute('data-property-id', propertyId);
      script.setAttribute('data-app-client-key', process.env.NEXT_PUBLIC_CHATBOT_APP_CLIENT_KEY);
      script.setAttribute('data-property-name', propertyName);
      script.setAttribute('data-api-base-url', process.env.NEXT_PUBLIC_CHATBOT_API_URL);
      script.setAttribute('data-ws-base-url', process.env.NEXT_PUBLIC_CHATBOT_WS_URL);
      if (process.env.NEXT_PUBLIC_CHATBOT_VERCEL_PROTECTION_BYPASS) {
        script.setAttribute(
          'data-vercel-protection-bypass',
          process.env.NEXT_PUBLIC_CHATBOT_VERCEL_PROTECTION_BYPASS
        );
      }

      script.setAttribute('data-locale', locale);
      document.head.appendChild(script);
    } else if (process.env.NEXT_PUBLIC_TRIPLA_CHATBOT_URL && chatbotKey) {
      const script = document.createElement('script');
      script.id = 'chatbot';
      script.src = process.env.NEXT_PUBLIC_TRIPLA_CHATBOT_URL;
      script.setAttribute('data-triplabot-code', chatbotKey);
      document.head.appendChild(script);
    }
  },
  locale: {
    get: (): string | null => localStorage.getItem('triplabot_locale'),
    set: (locale: string): void => {
      if (locale) {
        localStorage.setItem('triplabot_locale', locale);
      }
    },
  },
};
